import React from "react";
import { Link } from "react-router-dom";
import {
  MapPin,
  Maximize2,
  ArrowRight,
  Eye,
  Building2,
} from "lucide-react";
import { motion } from "framer-motion";

export const galleryItems = [
  {
    id: "premium-french-rowhouses",
    title: "Premium French-Inspired Rowhouses",
    category: "villas",
    categoryLabel: "Luxury Villas & Rowhouses",
    location: "Soukya Road, Whitefield, Bengaluru",
    price: "₹2.40 Cr Onwards",
    tag: "EOI Open",
    tagColor: "bg-amber-500",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/premium-french-rowhouses",
    description:
      "Ultra-exclusive French classical architecture featuring landscaped inner courtyards, private sundecks, and opulent double-height living areas nestled in a 20-acre enclave.",
    features: ["20 Acres Enclave", "242 Rowhouses", "Private Terrace Garden", "Vastu Compliant"],
  },
  {
    id: "brigade-granada",
    title: "Brigade Granada Landmark Township",
    category: "apartments",
    categoryLabel: "High-Rise Apartments",
    location: "Seegahalli Road, East Bengaluru",
    price: "₹1.65 Cr Onwards",
    tag: "Iconic Towers",
    tagColor: "bg-blue-600",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/brigade-granada",
    description:
      "A 40+ acre futuristic integrated township with 55-floor iconic towers, panoramic city views, high-street retail, and seamless access to ITPL and KR Puram.",
    features: ["55-Floor High Rise", "40+ Acres Campus", "Metro Proximity", "World-class Clubhouse"],
  },
  {
    id: "sanjeevini-heliconia",
    title: "Sanjeevini Heliconia",
    category: "villas",
    categoryLabel: "Luxury Villas & Rowhouses",
    location: "Soukya Road, Whitefield, Bengaluru",
    price: "₹1.85 Cr Onwards",
    tag: "RERA Registered",
    tagColor: "bg-emerald-600",
    image:
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/sanjeevini-heliconia",
    description:
      "Serene contemporary boutique homes engineered with premium Italian marble flooring, expansive master balconies, and private green outdoor zones.",
    features: ["Boutique Community", "Zero Common Walls", "Clubhouse & Pool", "Ready Possession"],
  },
  {
    id: "sumadhura-edition",
    title: "Folium by Sumadhura",
    category: "apartments",
    categoryLabel: "High-Rise Apartments",
    location: "Whitefield, Bengaluru",
    price: "₹73,000/mo or ₹1.9 Cr",
    tag: "Ready Possession",
    tagColor: "bg-purple-600",
    image:
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/sumadhura-edition",
    description:
      "Lush foliage-themed residential haven with 80% open landscape, infinity pool deck, tennis court, and sunlit 3 & 4 BHK residences.",
    features: ["3 & 4 BHK Luxury", "80% Green Open Space", "Infinity Pool", "Adjacent to Tech Parks"],
  },
  {
    id: "sobha-one-world",
    title: "Sobha OneWorld Iconic Residences",
    category: "apartments",
    categoryLabel: "High-Rise Apartments",
    location: "Greater Whitefield, Bengaluru",
    price: "₹13,999 / sft",
    tag: "New Launch",
    tagColor: "bg-red-600",
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/sobha-one-world",
    description:
      "German-engineered construction excellence by Sobha. Impeccable finishes, floor-to-ceiling soundproof glazing, and high-speed elevators.",
    features: ["Signature Sobha Craft", "1,100 – 1,542 ft²", "RERA Approved", "Club OneWorld"],
  },
  {
    id: "poulomi-florique",
    title: "Poulomi Florique Skyline Residences",
    category: "apartments",
    categoryLabel: "High-Rise Apartments",
    location: "Thanisandra Main Road, Bengaluru",
    price: "₹1.45 Cr Onwards",
    tag: "Under Construction",
    tagColor: "bg-amber-600",
    image:
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/poulomi-florique",
    description:
      "Soaring towers on Bangalore's fastest-growing international airport corridor. Grand reception lobby, amphitheater, and sky lounge.",
    features: ["1,585 – 2,740 ft²", "Direct Airport Corridor", "Sky Deck Amenities", "Dec 2028 Possession"],
  },
  {
    id: "rivera-edition",
    title: "Rivera Edition (Prestige Waterford)",
    category: "apartments",
    categoryLabel: "High-Rise Apartments",
    location: "ECC Road, Whitefield, Bengaluru",
    price: "₹2.10 Cr Onwards",
    tag: "Prestige Standard",
    tagColor: "bg-cyan-600",
    image:
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/rivera-edition",
    description:
      "Prestige Group's benchmark residential layout with expansive cross-ventilated living rooms, manicured gardens, and premier sports complexes.",
    features: ["1,800 – 2,950 ft²", "ECC Road Prestige Belt", "Olympic Sized Pool", "Bank Approved"],
  },
  {
    id: "riviera-north-edition",
    title: "Riviera North Edition",
    category: "apartments",
    categoryLabel: "High-Rise Apartments",
    location: "North Bengaluru Lakefront",
    price: "₹2.20 Cr Onwards",
    tag: "Waterfront Living",
    tagColor: "bg-teal-600",
    image:
      "https://images.unsplash.com/photo-1600565193348-f74bd3c7ccdf?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/riviera-north-edition",
    description:
      "Breathtaking lakefront views from every balcony. Private clubhouse, rooftop infinity pool, and high-speed commute to Hebbal & Yelahanka.",
    features: ["Lakefront Balconies", "Rooftop Infinity Pool", "Private Jogging Track", "VIP Concierge"],
  },
  {
    id: "goyal-orchid",
    title: "Goyal Orchid Ready Residences",
    category: "rentals",
    categoryLabel: "Ready-to-Move Rentals",
    location: "Thanisandra, North Bengaluru",
    price: "₹45,000 / month",
    tag: "Verified Rental",
    tagColor: "bg-emerald-600",
    image:
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/goyal-orchid",
    description:
      "Fully furnished 3 BHK ready-to-move apartment with modular kitchen, ACs, power backup, and dedicated covered car parking.",
    features: ["3 Beds • 2 Baths", "1,200 ft² Area", "Modular Kitchen", "Immediate Move-in"],
  },
  {
    id: "painting-showcase",
    title: "Asian Paints Royale Villa Transformation",
    category: "interiors",
    categoryLabel: "Interiors & Painting",
    location: "Indiranagar & Whitefield Residences",
    price: "Customised Packages",
    tag: "1-Yr Warranty",
    tagColor: "bg-pink-600",
    image:
      "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/painting-services",
    description:
      "Complete interior aesthetic overhaul with dustless mechanized sanding, Italian Stucco accent walls, and exterior waterproof protection.",
    features: ["Dust-Free Mechanized Prep", "Royale Luxury Emulsion", "Damp-Proofing Included", "48h Rapid Start"],
  },
  {
    id: "furniture-showcase",
    title: "Curated Scandinavian Modular Living",
    category: "interiors",
    categoryLabel: "Interiors & Painting",
    location: "Bellandur & Sarjapur Suites",
    price: "Rent from ₹1,499/mo",
    tag: "Turnkey Setup",
    tagColor: "bg-violet-600",
    image:
      "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/rental-furnitures",
    description:
      "Bespoke solid wood living room ensemble, ergonomic work-from-home suites, and smart appliances delivered and assembled within 72 hours.",
    features: ["Zero Security Deposit", "Free Annual Relocation", "Solid Hardwood Build", "Free Assembly"],
  },
  {
    id: "property-management-showcase",
    title: "HousyHunt Managed Executive Penthouse",
    category: "villas",
    categoryLabel: "Luxury Villas & Rowhouses",
    location: "Outer Ring Road, Bengaluru",
    price: "Managed by HousyHunt",
    tag: "Active Care",
    tagColor: "bg-red-600",
    image:
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=85",
    targetUrl: "/property-management",
    description:
      "Complete owner representation: corporate MNC tenant placed, 100% automated rent disbursement, and quarterly digital audit logs.",
    features: ["MNC Corporate Tenant", "Automated Rent Escrow", "Quarterly Video Audits", "24/7 Support"],
  },
];

const GalleryGrid = ({ searchQuery, selectedCategory, onOpenLightbox }) => {
  const filtered = galleryItems.filter((item) => {
    const matchesCat =
      selectedCategory === "all" || item.category === selectedCategory;
    const matchesSearch =
      searchQuery.trim() === "" ||
      item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.categoryLabel.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCat && matchesSearch;
  });

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-12 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-red-50 text-red-600 border border-red-100 text-xs font-bold uppercase tracking-wider mb-3">
              Photo & Tour Showcase
            </span>
            <h2 className="text-3xl sm:text-5xl font-black text-gray-900 tracking-tight">
              Featured Developments
            </h2>
            <p className="mt-3 text-gray-600 max-w-2xl text-base sm:text-lg">
              Click any photo to open high-resolution gallery view or click the direct button to navigate to the complete project / service page.
            </p>
          </div>
          <div className="text-sm font-semibold text-gray-500">
            Displaying <span className="text-red-600 font-bold">{filtered.length}</span> gallery showcases
          </div>
        </div>

        {/* Empty State */}
        {filtered.length === 0 && (
          <div className="text-center py-20 bg-white rounded-3xl border border-gray-200 p-8 shadow-sm">
            <Building2 className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-bold text-gray-800">No properties found</h3>
            <p className="text-gray-500 mt-2 max-w-md mx-auto">
              No gallery items match "{searchQuery}". Try searching for Whitefield, Thanisandra, Rowhouses, or Apartments.
            </p>
          </div>
        )}

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filtered.map((item, index) => {
            return (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: (index % 3) * 0.1 }}
                className="group flex flex-col bg-white rounded-3xl overflow-hidden border border-gray-200/90 shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-1.5"
              >
                {/* Image Container with Hover Trigger */}
                <div
                  className="relative h-64 overflow-hidden cursor-pointer"
                  onClick={() => onOpenLightbox(item)}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-108 transition-transform duration-700 ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

                  {/* Status Tag */}
                  <span
                    className={`absolute top-4 left-4 ${item.tagColor} text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg`}
                  >
                    {item.tag}
                  </span>

                  {/* Quick Expand Button */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onOpenLightbox(item);
                    }}
                    title="Open Fullscreen Lightbox"
                    className="absolute top-4 right-4 w-10 h-10 rounded-2xl bg-black/60 hover:bg-red-600 text-white flex items-center justify-center backdrop-blur-md transition-colors shadow-md"
                  >
                    <Maximize2 className="w-4 h-4" />
                  </button>

                  {/* Bottom Image Overlay Info */}
                  <div className="absolute bottom-4 left-4 right-4">
                    <span className="text-[11px] font-bold uppercase tracking-wider text-red-300">
                      {item.categoryLabel}
                    </span>
                    <h3 className="text-lg sm:text-xl font-black text-white leading-snug">
                      {item.title}
                    </h3>
                  </div>
                </div>

                {/* Body Content */}
                <div className="p-6 flex-1 flex flex-col justify-between">
                  <div>
                    {/* Location & Price */}
                    <div className="flex items-center justify-between gap-2 mb-3">
                      <div className="flex items-center gap-1.5 text-xs font-medium text-gray-500">
                        <MapPin className="w-3.5 h-3.5 text-red-500 shrink-0" />
                        <span className="truncate max-w-[190px]">{item.location}</span>
                      </div>
                      <span className="text-sm font-black text-gray-900">
                        {item.price}
                      </span>
                    </div>

                    <p className="text-gray-600 text-xs sm:text-sm leading-relaxed mb-4 line-clamp-2">
                      {item.description}
                    </p>

                    {/* Features badges */}
                    <div className="flex flex-wrap gap-1.5 mb-5">
                      {item.features?.slice(0, 3).map((feat, idx) => (
                        <span
                          key={idx}
                          className="px-2.5 py-1 rounded-lg bg-gray-100 text-gray-700 text-[11px] font-medium"
                        >
                          {feat}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Action Link to Project/Service Page */}
                  <div className="pt-4 border-t border-gray-100 flex items-center gap-3">
                    <Link
                      to={item.targetUrl}
                      className="flex-1 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-2xl bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold text-xs sm:text-sm shadow-md shadow-red-600/20 hover:shadow-lg hover:shadow-red-600/30 transition-all duration-200 group/btn"
                    >
                      <span>Explore Project Page</span>
                      <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                    </Link>

                    <button
                      onClick={() => onOpenLightbox(item)}
                      title="Quick Preview"
                      className="w-11 h-11 rounded-2xl bg-gray-100 hover:bg-gray-200 text-gray-700 flex items-center justify-center transition-colors shrink-0"
                    >
                      <Eye className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default GalleryGrid;
